// Recovered compiled webpack factory 44761. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getSortedRouteObjects: function () {
        return a;
      },
      getSortedRoutes: function () {
        return n;
      },
    }));
  class r {
    insert(e) {
      this._insert(e.split("/").filter(Boolean), [], !1);
    }
    smoosh() {
      return this._smoosh();
    }
    _smoosh(e) {
      void 0 === e && (e = "/");
      let t = [...this.children.keys()].sort();
      (null !== this.slugName && t.splice(t.indexOf("[]"), 1),
        null !== this.restSlugName && t.splice(t.indexOf("[...]"), 1),
        null !== this.optionalRestSlugName && t.splice(t.indexOf("[[...]]"), 1));
      let r = t
        .map((t) => this.children.get(t)._smoosh("" + e + t + "/"))
        .reduce((e, t) => [...e, ...t], []);
      if (
        (null !== this.slugName &&
          r.push(...this.children.get("[]")._smoosh(e + "[" + this.slugName + "]/")),
        !this.placeholder)
      ) {
        let t = "/" === e ? "/" : e.slice(0, -1);
        if (null != this.optionalRestSlugName)
          throw Object.defineProperty(
            Error(
              'You cannot define a route with the same specificity as a optional catch-all route ("' +
                t +
                '" and "' +
                t +
                "[[..." +
                this.optionalRestSlugName +
                ']]").',
            ),
            "__NEXT_ERROR_CODE",
            { value: "E458", enumerable: !1, configurable: !0 },
          );
        r.unshift(t);
      }
      return (
        null !== this.restSlugName &&
          r.push(...this.children.get("[...]")._smoosh(e + "[..." + this.restSlugName + "]/")),
        null !== this.optionalRestSlugName &&
          r.push(
            ...this.children
              .get("[[...]]")
              ._smoosh(e + "[[..." + this.optionalRestSlugName + "]]/"),
          ),
        r
      );
    }
    _insert(e, t, n) {
      if (0 === e.length) {
        this.placeholder = !1;
        return;
      }
      if (n)
        throw Object.defineProperty(
          Error("Catch-all must be the last part of the URL."),
          "__NEXT_ERROR_CODE",
          { value: "E392", enumerable: !1, configurable: !0 },
        );
      let a = e[0];
      if (a.startsWith("[") && a.endsWith("]")) {
        let r = a.slice(1, -1),
          i = !1;
        if (
          (r.startsWith("[") && r.endsWith("]") && ((r = r.slice(1, -1)), (i = !0)),
          r.startsWith("…"))
        )
          throw Object.defineProperty(
            Error("Detected a three-dot character ('…') at ('" + r + "'). Did you mean ('...')?"),
            "__NEXT_ERROR_CODE",
            { value: "E147", enumerable: !1, configurable: !0 },
          );
        if (
          (r.startsWith("...") && ((r = r.substring(3)), (n = !0)),
          r.startsWith("[") || r.endsWith("]"))
        )
          throw Object.defineProperty(
            Error("Segment names may not start or end with extra brackets ('" + r + "')."),
            "__NEXT_ERROR_CODE",
            { value: "E421", enumerable: !1, configurable: !0 },
          );
        if (r.startsWith("."))
          throw Object.defineProperty(
            Error("Segment names may not start with erroneous periods ('" + r + "')."),
            "__NEXT_ERROR_CODE",
            { value: "E288", enumerable: !1, configurable: !0 },
          );
        function o(e, r) {
          if (null !== e && e !== r)
            throw Object.defineProperty(
              Error(
                "You cannot use different slug names for the same dynamic path ('" +
                  e +
                  "' !== '" +
                  r +
                  "').",
              ),
              "__NEXT_ERROR_CODE",
              { value: "E337", enumerable: !1, configurable: !0 },
            );
          (t.forEach((e) => {
            if (e === r)
              throw Object.defineProperty(
                Error(
                  'You cannot have the same slug name "' +
                    r +
                    '" repeat within a single dynamic path',
                ),
                "__NEXT_ERROR_CODE",
                { value: "E247", enumerable: !1, configurable: !0 },
              );
            if (e.replace(/\W/g, "") === a.replace(/\W/g, ""))
              throw Object.defineProperty(
                Error(
                  'You cannot have the slug names "' +
                    e +
                    '" and "' +
                    r +
                    '" differ only by non-word symbols within a single dynamic path',
                ),
                "__NEXT_ERROR_CODE",
                { value: "E499", enumerable: !1, configurable: !0 },
              );
          }),
            t.push(r));
        }
        if (n)
          if (i) {
            if (null != this.restSlugName)
              throw Object.defineProperty(
                Error(
                  'You cannot use both an required and optional catch-all route at the same level ("[...' +
                    this.restSlugName +
                    ']" and "' +
                    e[0] +
                    '" ).',
                ),
                "__NEXT_ERROR_CODE",
                { value: "E299", enumerable: !1, configurable: !0 },
              );
            (o(this.optionalRestSlugName, r), (this.optionalRestSlugName = r), (a = "[[...]]"));
          } else {
            if (null != this.optionalRestSlugName)
              throw Object.defineProperty(
                Error(
                  'You cannot use both an optional and required catch-all route at the same level ("[[...' +
                    this.optionalRestSlugName +
                    ']]" and "' +
                    e[0] +
                    '").',
                ),
                "__NEXT_ERROR_CODE",
                { value: "E300", enumerable: !1, configurable: !0 },
              );
            (o(this.restSlugName, r), (this.restSlugName = r), (a = "[...]"));
          }
        else {
          if (i)
            throw Object.defineProperty(
              Error('Optional route parameters are not yet supported ("' + e[0] + '").'),
              "__NEXT_ERROR_CODE",
              { value: "E435", enumerable: !1, configurable: !0 },
            );
          (o(this.slugName, r), (this.slugName = r), (a = "[]"));
        }
      }
      (this.children.has(a) || this.children.set(a, new r()),
        this.children.get(a)._insert(e.slice(1), t, n));
    }
    constructor() {
      ((this.placeholder = !0),
        (this.children = new Map()),
        (this.slugName = null),
        (this.restSlugName = null),
        (this.optionalRestSlugName = null));
    }
  }
  function n(e) {
    let t = new r();
    return (e.forEach((e) => t.insert(e)), t.smoosh());
  }
  function a(e, t) {
    let r = {},
      a = [];
    for (let n = 0; n < e.length; n++) {
      let o = t(e[n]);
      ((r[o] = n), (a[n] = o));
    }
    return n(a).map((t) => e[r[t]]);
  }
}
